module.exports = __webpack_public_path__ + "img/Frühlingsgefühle.679ee36e.jpg";